const React = require('react');
const FormControl = require('@material-ui/core/FormControl').default;
const InputLabel = require('@material-ui/core/InputLabel').default;
const Select = require('@material-ui/core/Select').default;
const selectProvider = require('../../../../../Select/provider');
const Arrow = require('../../../../../Select/ArrowBase');

module.exports = selectProvider((env) => {
  const _control = env.control || {};
  const {
    helperText,
    ...control
  } = _control;
  return (
    <div className="w rlv
      (f14|c0)>.MuiSelect-root
      (bc0-i)>.MuiSelect-root:h>.*-notchedOutline
      c0.38-i>.MuiSelect-root.Mui-disabled
      (pv13|ph25|c0-i)>.MuiOutlinedInput-input
      pr60>.MuiOutlinedInput-input*2
      (bgF|ph5|f12|ff$3|fw4)>.MuiFormLabel-root
      (c0-i)>.MuiInputBase-root
      (c0-i)>.MuiFormLabel-root:not[.Mui-error]
      (x20y17s100|x20y16s100@firefox)>.MuiInputLabel-formControl
      x20y-6s100(|@firefox)>.MuiInputLabel-outlined.MuiInputLabel-shrink
      (b1-i|olN|r9)>.*-notchedOutline
      (bcA-i)>:not[.Mui-error]>.*-notchedOutline
      (bc0-i)>:not[.Mui-error]:h>.*-notchedOutline
      (bc0)>.Mui-focused:not[.Mui-error]>.*-notchedOutline
      dn>.*-notchedOutline
    ">
      <FormControl
        {...control}
        className={'w ' + (control.className || '')}
        variant="outlined"
      >
        <InputLabel
          {...env.label}
        />
        <Select
          {...env.select}
          className="w"
          IconComponent={Arrow}
        />
      </FormControl>
      {
        control.error ? (<div className="rlv">
          <div
            className="abs sh st f11 cF00 fw4 wmin130"
          >{helperText || 'Invalid value'}</div>
        </div>) : null
      }
    </div>
  );
});
